import { Component, OnInit, ChangeDetectionStrategy, Input, ElementRef, inject } from '@angular/core';
import { UsersService } from 'app/services/users.service';
import { LocalizationService } from 'app/system/mobile-system/services/localization.service';
import Map from 'ol/Map';
import ControlScaleLine from 'ol/control/ScaleLine';

@Component({
    selector: 'app-scaleline',
    templateUrl: './scale-line.component.html',
    styleUrls: ['./scale-line.component.css'],
    standalone: false
})
export class ScaleLineComponent implements OnInit {
  @Input() map: Map;
  control: ControlScaleLine;
  localizationService: LocalizationService = inject(LocalizationService);

  constructor(private elementRef: ElementRef) { }

  ngOnInit() {
    this.control = new ControlScaleLine({
      target: this.elementRef.nativeElement,
      units: this.localizationService.IsMetric() ? 'metric' : 'imperial'
    });
    this.map.addControl(this.control);
  }
}